<footer class="page-footer">
  <div class="page-footer__divider"></div>

  <!-- Social icons -->
  <div class="page-footer__socials">
    <a
      href="https://www.instagram.com/leesey.reviews?utm_source=leeseyreviews.com&utm_medium=website&utm_campaign=footer&utm_content=instagram"
      target="_blank"
      rel="noopener noreferrer"
      class="page-footer__social-link"
      aria-label="Instagram"
      (click)="analytics.trackEvent('footer_instagram')"
    >
      <i class="fa-brands fa-instagram"></i>
    </a>
    <a
      href="https://www.goodreads.com/user/show/37847324?utm_source=leeseyreviews.com&utm_medium=website&utm_campaign=footer&utm_content=goodreads"
      target="_blank"
      rel="noopener noreferrer"
      class="page-footer__social-link"
      aria-label="Goodreads"
      (click)="analytics.trackEvent('footer_goodreads')"
    >
      <i class="fa-brands fa-goodreads"></i>
    </a>
  </div>

  <!-- Buy me a coffee -->
  <a href="https://buy.stripe.com/5kQ7sKdFe88Ke6MfVF7g400?utm_source=leeseyreviews.com&utm_medium=website&utm_campaign=footer&utm_content=buy_me_coffee" target="_blank" rel="noopener noreferrer" class="page-footer__coffee" (click)="analytics.trackEvent('footer_buy_me_coffee')">
    <i class="fa-solid fa-mug-hot"></i> Buy me a coffee
  </a>

  <!-- Disclaimer -->
  <p class="page-footer__disclaimer">
    Insights are for fictional purposes only and do not constitute
    <br/>
    medical advice.
  </p>
</footer>
